import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getRequest } from "../services";
import toast from "react-hot-toast";

const initialState = {
  stats: [],
  loading: false,
  error: null,
};

export const fetchStats = createAsyncThunk(
  "dashboard/fetchStats",
  async (filters = {}, { rejectWithValue }) => {
    try {
      // Build query parameters
      const queryParams = new URLSearchParams();
      
      // Add filter parameters if they exist
      if (filters.campusId) {
        queryParams.append('campusId', filters.campusId);
      }
      if (filters.classId) {
        queryParams.append('classId', filters.classId);
      }
      if (filters.sectionId) {
        queryParams.append('sectionId', filters.sectionId);
      }
      if (filters.startDate) {
        queryParams.append('startDate', filters.startDate);
      }
      if (filters.endDate) {
        queryParams.append('endDate', filters.endDate);
      }

      // Construct the URL with query parameters
      const url = `/api/AdminDashboard/statics${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
      
      const response = await getRequest(url);
      console.log("API Response:", response.data);
      
      if (response.status !== 200) throw new Error("Failed to fetch statistics");
      
      return response.data;
    } catch (error) {
      console.error("Error fetching stats:", error);
      return rejectWithValue(error.message);
    }
  }
);

const statsSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {
    clearStats: (state) => {
      state.stats = [];
      state.error = null;
    },
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchStats.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchStats.fulfilled, (state, action) => {
        state.loading = false;
        state.stats = action.payload?.data || {};
      })
      .addCase(fetchStats.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        toast.error(action.payload || "Failed to fetch statistics");
      });
  },
});

export const { clearStats, clearError } = statsSlice.actions;
export default statsSlice.reducer;